import { IFilter, IRootState } from '@/store/types/IRootState';
import FilterServiceBase from '@/services/FilterServiceBase';

const manufacturerFilterGetters = {
    getNManufacturerFilters: (state: IRootState) => (numberFiltersToShow: number): IFilter[] => {
        return FilterServiceBase.getters.getNFilters(
            state.manufacturerFilters.filters,
            numberFiltersToShow,
            state.manufacturerFilters.showAllFilters);
    },
    getNumberOfRemainingManufacturerFilters: (state: IRootState) => (numberFiltersToShow: number): number => {
        return FilterServiceBase.getters.getNumberOfRemainingFilters(
            state.manufacturerFilters.filters,
            numberFiltersToShow);
    },
    getCheckedManufacturerFilters: (state: IRootState): IFilter[] => {
        return state.manufacturerFilters.filters
            .filter((currentFilter: IFilter) => currentFilter.checked);
    },
    getShowAllManufacturerFilters: (state: IRootState): boolean => {
        return state.manufacturerFilters.showAllFilters;
    },
    getManufacturerFiltersLength: (state: IRootState): number => {
        return state.manufacturerFilters.filters.length;
    },
    hasManufacturerFilters(state: IRootState): boolean {
        return FilterServiceBase.getters.hasFilters(state.manufacturerFilters.filters);
      },
    getShowFilterGroupManufacturerFilters: (state: IRootState): boolean => {
        return state.manufacturerFilters.showFilterGroup;
    },
    displayManufacturerFilter: (state: IRootState): boolean => {
        return !(state.manufacturerFilters.filters.length === 1 && state.manufacturerFilters.filters[0].count === state.itemsCounter);
    },
};
export default manufacturerFilterGetters;
